export enum IconType {
  AccountBox = "account_box",
  AccountCircle = "account_circle",
  AccountCircleOff = "account_circle_off",
  Add = "add",
  AddAd = "add_ad",
  AddCircle = "add_circle",
  Album = "album",
  AreaChart = "area_chart",
  ArrowDownwardAlt = "arrow_downward_alt",
  ArrowLeftAlt = "arrow_left_alt",
  ArrowUpwardAlt = "arrow_upward_alt",
  Article = "article",
  Artist = "artist",
  Assignment = "assignment",
  AssignmentInd = "assignment_ind",
  AudioVideoReceiver = "audio_video_receiver",
  Book2 = "book_2",
  Box = "box",
  BoxAdd = "box_add",
  BusinessCenter = "business_center",
  Calculate = "calculate",
  CalendarMonth = "calendar_month",
  CameraSwitch = "cameraswitch",
  Campaign = "campaign",
  CardsStar = "cards_star",
  ChatAddOn = "chat_add_on",
  Check = "check",
  CheckBox = "check_box",
  CheckCircle = "check_circle",
  ChevronRight = "chevron_right",
  Close = "close",
  CloudDownload = "cloud_download",
  Compress = "compress",
  ContactEmergency = "contact_emergency",
  ContactMail = "contact_mail",
  ContentCopy = "content_copy",
  ControlCamera = "control_camera",
  CurrencyExchange = "currency_exchange",
  DecimalIncrease = "decimal_increase",
  DeleteForever = "delete_forever",
  DeleteSweep = "delete_sweep",
  Die = "ifl",
  Download = "download",
  Drafts = "drafts",
  DragIndicator = "drag_indicator",
  EditSquare = "edit_square",
  Event = "event",
  Expand = "expand",
  ExpandAll = "expand_all",
  FeatureSearch = "feature_search",
  FilterAlt = "filter_alt",
  FilterAltOff = "filter_alt_off",
  FinanceChip = "finance_chip",
  Flag = "flag",
  Flare = "flare",
  Folder = "folder",
  FormatListNumbered = "format_list_numbered",
  FormsAddOn = "forms_add_on",
  FrameInspect = "frame_inspect",
  GalleryThumbnail = "gallery_thumbnail",
  Genres = "genres",
  Hardware = "hardware",
  Headphones = "headphones",
  Hearing = "hearing",
  Help = "help",
  HistoryEdu = "history_edu",
  ImageSearch = "image_search",
  ImportContacts = "import_contacts",
  Inbox = "inbox",
  Info = "info",
  Keep = "keep",
  KeepOff = "keep_off",
  Key = "key",
  KeyboardArrowDown = "keyboard_arrow_down",
  KeyboardArrowUp = "keyboard_arrow_up",
  KeyboardDoubleArrowDown = "keyboard_double_arrow_down",
  KeyboardDoubleArrowLeft = "keyboard_double_arrow_left",
  KeyboardDoubleArrowRight = "keyboard_double_arrow_right",
  KeyboardDoubleArrowUp = "keyboard_double_arrow_up",
  KidStar = "kid_star",
  LaptopMac = "laptop_mac",
  LayersClear = "layers_clear",
  LibraryAdd = "library_add",
  ListAlt = "list_alt",
  LocalMall = "local_mall",
  Login = "login",
  Logout = "logout",
  Lyrics = "lyrics",
  Mail = "mail",
  MarkAsUnread = "mark_as_unread",
  Memory = "memory",
  Menu = "menu",
  MenuOpen = "menu_open",
  ModelTraining = "model_training",
  MoreVertical = "more_vert",
  MusicCast = "music_cast",
  OpenInNew = "open_in_new",
  Paid = "paid",
  Palette = "palette",
  Passkey = "passkey",
  PersonAdd = "person_add",
  Photo = "photo",
  PhotoCamera = "photo_camera",
  Pin = "pin",
  PlayCircle = "play_circle",
  PlaylistAdd = "playlist_add",
  PriceChange = "price_change",
  Public = "public",
  QRCode2 = "qr_code_2",
  QRCode2Add = "qr_code_2_add",
  Refresh = "refresh",
  Remove = "remove",
  Reply = "reply",
  Rotate90DegreesCcw = "rotate_90_degrees_ccw",
  Routine = "routine",
  Save = "save",
  Search = "search",
  Sell = "sell",
  Settings = "settings",
  Share = "share",
  Shelves = "shelves",
  ShoppingBasket = "shopping_basket",
  SpeakerGroup = "speaker_group",
  Stacks = "stacks",
  Star = "star",
  Store = "store",
  TabInactive = "tab_inactive",
  ThreeDimensionalRotation = "3d_rotation",
  Timer = "timer",
  Today = "today",
  Translate = "translate",
  TravelExplore = "travel_explore",
  Visibility = "visibility",
  Wallet = "wallet",
  ZoomIn = "zoom_in"
}
